import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';

import { createCalculationDiscount } from './../../api/createCalculationDiscount';

export const useCalculationDiscountMutation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  const { mutate, isLoading } = useMutation(createCalculationDiscount, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_SERVICES, {
        refetchInactive: true,
      });
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_TYPE, {
        refetchInactive: true,
      });
      successToast(t('Discount saved successfully.'));
    },
    onError: () => errorToast(),
  });

  return {
    isLoading,
    mutate,
  };
};
